import React from 'react'

const YellowUnderline: React.FunctionComponent = () => {
  return <>
    <svg fill="none" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 411 9"><path d="M409.806 0C344.845.223 279.893.677 214.95 1.36c-44.991.482-89.955 1.13-134.947 1.758-23.31.335-46.622.635-69.933.9-2.917.134-5.714.958-8.02 2.365C1.25 6.865-1.584 9.041 1.196 9c41.783-.44 83.594-1.088 125.377-1.653 51.523-.712 103.019-1.277 154.489-1.695 39.956-.321 79.904-.544 119.843-.67 2.926-.118 5.732-.952 8.02-2.386.828-.46 3.662-2.616.882-2.595Z" fill="#FFD100" /></svg>
  </>
}

export default YellowUnderline